import { datadogLogs } from "@datadog/browser-logs";

import { getEnvironment } from "utils/environment";

const sendErrorReport = (msg: string, extra: unknown = {}): void => {
  if (getEnvironment() === "production") {
    datadogLogs.logger.error(msg, extra as object);
  }
};

const logger = {
  error: sendErrorReport,
  info: (_: string, __: unknown = {}): void => undefined,
  warning: (_: string, __: unknown = {}): void => undefined,
} as const;

export { logger as Logger };
